import React from 'react';
import { OrganizationSettingsComponent } from '../organization';

export function OrganizationSettingsTab() {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-secondary-900 dark:text-white mb-2">
          Organization Configuration
        </h3>
        <p className="text-secondary-600 dark:text-secondary-400 mb-6">
          Manage organization-wide settings including security, authentication, and integrations.
        </p>
      </div>
      
      <OrganizationSettingsComponent />
    </div>
  );
}
